// extracted by mini-css-extract-plugin
export default {"icon":"PageSkeleton_icon__SWgpS","main":"PageSkeleton_main__rpVoF","mobileMenu":"PageSkeleton_mobileMenu__L+7Dd"};